import HttpRequest from '@/util/HttpRequest'

// 진행 중인 API 호출을 추적하기 위한 객체
const pendingPromises = {}

export default {

  /**
  * 회원리스트 불러오기
  * @params {page, perPage}
  */
  async LOAD_MEMBERS ({commit}, params) {

    const option = {
      params: {
        page:params.page,
        perPage:params.perPage,
        keyword:params.keyword,
        name:params.name,
        email:params.email,
        username:params.username,
        company:params.company,
        section:params.section,
        field:params.field,
        projectId:params.projectId,
      }
    }

    /* TODO : 로컬 저장
    const _key = `/api/v1/member?${JSON.stringify(option)}/${params.searchType}`
    const members = localStorage.getItem(_key)
    if (members) {
      const data = JSON.parse(members)
      commit('LOAD_MEMBERS', data)
      return data
    }
    */
    const searchType = params.searchType

    // 중복 호출 방지를 위한 키 생성
    const promiseKey = `LOAD_MEMBERS_${JSON.stringify(option)}_${searchType}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    if (searchType === 'and') {
      const promise = new Promise((resolve, reject) => {
        HttpRequest.get('/api/v1/member/filter', option)
          .then(response => {
            // mutations 메소드 호출
            commit('LOAD_MEMBERS', response)
            resolve(response)
          }).catch(err => reject(err))
          .finally(() => {
            // 요청 완료 후 진행 중인 Promise에서 제거
            delete pendingPromises[promiseKey]
          })
      })

      // 진행 중인 Promise로 등록
      pendingPromises[promiseKey] = promise
      return promise
    } else {
      const promise = new Promise((resolve, reject) => {
        HttpRequest.get('/api/v1/member', option)
          .then(response => {
            // mutations 메소드 호출
            commit('LOAD_MEMBERS', response)
            resolve(response)
          }).catch(err => reject(err))
          .finally(() => {
            // 요청 완료 후 진행 중인 Promise에서 제거
            delete pendingPromises[promiseKey]
          })
      })

      // 진행 중인 Promise로 등록
      pendingPromises[promiseKey] = promise
      return promise
    }
  },

  /*회원리스트 모두 불러오기*/
  async LOAD_MEMBERS_ALL ({commit}, params) {
    const _key = '/api/v1/member/all'
    const memberAll = localStorage.getItem(_key)
    if (memberAll) {
      const data = JSON.parse(memberAll)
      commit('LOAD_MEMBERS_ALL', data)
      return data
    }

    const option = {
      params: {
        page:1,
        perPage:10000,
        projectId:params.projectId
      }
    }

    // 중복 호출 방지를 위한 키 생성
    const promiseKey = `LOAD_MEMBERS_ALL_${JSON.stringify(option)}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    const promise = new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/member', option)
        .then(response => {
          localStorage.setItem(_key, JSON.stringify(response))

          // mutations 메소드 호출
          commit('LOAD_MEMBERS_ALL', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  },

  /**
  * 회원정보 불러오기
  * @params {userId}
  */
  async LOAD_MEMBER ({commit}, params) {

    const option = {
      params: {
      }
    }

    const userId = params.userId

    // 중복 호출 방지를 위한 키 생성
    const promiseKey = `LOAD_MEMBER_${userId}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    const promise = new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/member/${userId}`, option)
        .then(response => {
          // mutations 메소드 호출
          commit('LOAD_MEMBER', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  },

  async LOAD_MEMBER_DETAIL ({commit, state}, params) {
    const option = {
      params: {
        projectId: typeof params !== 'undefined' ? params.project_id : undefined,
      }
    }

    // 강제 갱신 플래그 확인 (로그인 시 사용)
    const forceRefresh = params && params.forceRefresh

    // 캐시 키 생성
    const cacheKey = `member_detail_${option.params.projectId}`
    const cacheTimestampKey = `${cacheKey}_timestamp`

    // 중복 호출 방지를 위한 키 생성
    const promiseKey = `LOAD_MEMBER_DETAIL_${option.params.projectId}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    // 강제 갱신이 아닌 경우 캐시 확인
    if (!forceRefresh) {
      // localStorage에서 캐시된 데이터 확인
      const cachedData = localStorage.getItem(cacheKey)
      const cacheTimestamp = localStorage.getItem(cacheTimestampKey)

      if (cachedData && cacheTimestamp) {
        const now = new Date().getTime()
        const cacheTime = parseInt(cacheTimestamp)
        const CACHE_DURATION = 24 * 60 * 60 * 1000 // 24시간 (밀리초)

        // 캐시가 유효한 경우 (24시간 이내)
        if (now - cacheTime < CACHE_DURATION) {
          try {
            const memberInfo = JSON.parse(cachedData)
            console.log('캐시된 회원 정보 사용:', memberInfo)

            // Vuex state에도 저장
            commit('LOAD_MEMBER_DETAIL', memberInfo)
            return Promise.resolve(memberInfo)
          } catch (error) {
            console.error('캐시된 회원 정보 파싱 오류:', error)
            // 파싱 오류 시 캐시 삭제하고 API 호출
            localStorage.removeItem(cacheKey)
            localStorage.removeItem(cacheTimestampKey)
          }
        } else {
          console.log('캐시 만료됨, 새로운 데이터 로드')
          // 캐시 만료 시 삭제
          localStorage.removeItem(cacheKey)
          localStorage.removeItem(cacheTimestampKey)
        }
      }

      // Vuex state에 유효한 데이터가 있고, projectId가 일치하는 경우
      if (state.memberInfo && state.memberInfo.id && `${state.memberInfo.projectId}` === `${option.params.projectId}`) {
        console.log('Vuex state의 회원 정보 사용:', state.memberInfo)
        return Promise.resolve(state.memberInfo)
      }
    }

    // API 호출이 필요한 경우
    console.log(forceRefresh ? '강제 갱신으로 API 호출' : '새로운 회원 정보 API 호출')

    const promise = new Promise((resolve, reject) => {
      HttpRequest.get('/api/v1/member/detail', option)
        .then(response => {
          // response 내에 projectId 값을 추가한다.
          response.projectId = option.params.projectId

          // localStorage에 캐시 저장
          localStorage.setItem(cacheKey, JSON.stringify(response))
          localStorage.setItem(cacheTimestampKey, new Date().getTime().toString())
          console.log('회원 정보 캐시 저장 완료')

          // mutations 메소드 호출
          commit('LOAD_MEMBER_DETAIL', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  },


  /**
  * 회원 가입
  * @params {
      userId,
      name, surname, password, nickname,
      birthdate, mobile, phone,
      home_zip, home_address_1, home_address_2,
      company_zip, company_address_1, company_address_2,
      subscribe_email, subscribe_sms, mail_destination, is_activated
    }
  */
  async REGISTER_MEMBER ({commit}, params) {

    const option = {
      params: {
      }
    }

    if (params.username) option.params.username = params.username
    if (params.email) option.params.email = params.email

    if (params.name) option.params.name = params.name
    if (params.surname) option.params.surname = params.surname
    if (params.password) option.params.password = params.password
    if (params.password_confirmation) option.params.password_confirmation = params.password_confirmation
    if (params.nickname) option.params.nickname = params.nickname
    if (params.birthdate) option.params.birthdate = params.birthdate
    if (params.mobile) option.params.mobile = params.mobile
    if (params.phone) option.params.phone = params.phone
    if (params.home_zip) option.params.home_zip = params.home_zip
    if (params.home_address_1) option.params.home_address_1 = params.home_address_1
    if (params.home_address_2) option.params.home_address_2 = params.home_address_2
    if (params.company_zip) option.params.company_zip = params.company_zip
    if (params.company_address_1) option.params.company_address_1 = params.company_address_1
    if (params.company_address_2) option.params.company_address_2 = params.company_address_2
    if (params.subscribe_email) option.params.subscribe_email = params.subscribe_email
    if (params.subscribe_sms) option.params.subscribe_sms = params.subscribe_sms
    if (params.mail_destination) option.params.mail_destination = params.mail_destination
    if (params.avatar) option.params.avatar = params.avatar

    // is_activated ={0:계정 비활성화, 1:계정 활성화)
    // 기획 변경에 따라 수정될 수 있다.
    // 가입 이후 바로 로그인을 할수 있게 하려면, 1로 설정하고,
    // 가입 이후 별도 인증을 거쳐야 로그인할 수 있게 하려면, 0으로 설정한다.
    // if(params.is_activated) option.params.is_activated = params.is_activated;
    option.params.is_activated = 1

    // 중복 호출 방지를 위한 키 생성 (이메일과 사용자명 기준)
    const promiseKey = `REGISTER_MEMBER_${params.email}_${params.username}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    const promise = new Promise((resolve, reject) => {
      HttpRequest.put('/api/v1/member/', option.params)
        .then(response => {
          // mutations 메소드 호출
          commit('REGISTER_MEMBER', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  },

  async NONE_TOKEN_REGISTER_MEMBER ({commit}, params) {

    const option = {
      params: {
      }
    }

    if (params.username) option.params.username = params.username
    if (params.email) option.params.email = params.email

    if (params.name) option.params.name = params.name
    if (params.surname) option.params.surname = params.surname
    if (params.password) option.params.password = params.password
    if (params.password_confirmation) option.params.password_confirmation = params.password_confirmation
    if (params.nickname) option.params.nickname = params.nickname
    if (params.birthdate) option.params.birthdate = params.birthdate
    if (params.mobile) option.params.mobile = params.mobile
    if (params.phone) option.params.phone = params.phone
    if (params.home_zip) option.params.home_zip = params.home_zip
    if (params.home_address_1) option.params.home_address_1 = params.home_address_1
    if (params.home_address_2) option.params.home_address_2 = params.home_address_2
    if (params.company_zip) option.params.company_zip = params.company_zip
    if (params.company_address_1) option.params.company_address_1 = params.company_address_1
    if (params.company_address_2) option.params.company_address_2 = params.company_address_2
    if (params.subscribe_email) option.params.subscribe_email = params.subscribe_email
    if (params.subscribe_sms) option.params.subscribe_sms = params.subscribe_sms
    if (params.mail_destination) option.params.mail_destination = params.mail_destination
    if (params.avatar) option.params.avatar = params.avatar

    // is_activated ={0:계정 비활성화, 1:계정 활성화)
    // 기획 변경에 따라 수정될 수 있다.
    // 가입 이후 바로 로그인을 할수 있게 하려면, 1로 설정하고,
    // 가입 이후 별도 인증을 거쳐야 로그인할 수 있게 하려면, 0으로 설정한다.
    // if(params.is_activated) option.params.is_activated = params.is_activated;
    option.params.is_activated = 1

    // 중복 호출 방지를 위한 키 생성 (이메일과 사용자명 기준)
    const promiseKey = `NONE_TOKEN_REGISTER_MEMBER_${params.email}_${params.username}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    const promise = new Promise((resolve, reject) => {
      HttpRequest.none_token_put('/api/v1/member/', option.params)
        .then(response => {
          // mutations 메소드 호출
          commit('REGISTER_MEMBER', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  },


  /**
  * 회원정보 수정하기
  * @params {
      userId,
      name, surname, password, nickname,
      birthdate, mobile, phone,
      home_zip, home_address_1, home_address_2,
      company_zip, company_address_1, company_address_2,
      subscribe_email, subscribe_sms, mail_destination, is_activated
    }
  */
  async MODIFY_MEMBER ({commit}, params) {

    const option = {
      params: {
      }
    }

    const userId = params.userId

    if (params.name) option.params.name = params.name
    if (params.surname) option.params.surname = params.surname
    if (params.password_old) option.params.password_old = params.password_old;
    if (params.password) option.params.password = params.password
    if (params.password_confirmation) option.params.password_confirmation = params.password_confirmation
    if (params.nickname) option.params.nickname = params.nickname
    if (params.birthdate) option.params.birthdate = params.birthdate
    if (params.mobile) option.params.mobile = params.mobile
    if (params.phone) option.params.phone = params.phone
    if (params.home_zip) option.params.home_zip = params.home_zip
    if (params.home_address_1) option.params.home_address_1 = params.home_address_1
    if (params.home_address_2) option.params.home_address_2 = params.home_address_2
    if (params.company_zip) option.params.company_zip = params.company_zip
    if (params.company_address_1) option.params.company_address_1 = params.company_address_1
    if (params.company_address_2) option.params.company_address_2 = params.company_address_2
    if (params.subscribe_email) option.params.subscribe_email = params.subscribe_email
    if (params.subscribe_sms) option.params.subscribe_sms = params.subscribe_sms
    if (params.mail_destination) option.params.mail_destination = params.mail_destination
    if (params.is_activated) option.params.is_activated = params.is_activated
    if (params.avatar) option.params.avatar = params.avatar
    if (params.position) option.params.position = params.position
    if (params.rank) option.params.rank = params.rank
    if (params.department) option.params.department = params.department
    if (params.section) option.params.section = params.section

    // 중복 호출 방지를 위한 키 생성
    const promiseKey = `MODIFY_MEMBER_${userId}_${JSON.stringify(option.params)}`

    // 이미 진행 중인 요청이 있으면 해당 Promise 반환
    if (pendingPromises[promiseKey]) {
      return pendingPromises[promiseKey]
    }

    const promise = new Promise((resolve, reject) => {
      HttpRequest.post(`/api/v1/member/${userId}`, option.params)
        .then(response => {
          // mutations 메소드 호출
          commit('MODIFY_MEMBER', response)
          resolve(response)
        }).catch(err => reject(err))
        .finally(() => {
          // 요청 완료 후 진행 중인 Promise에서 제거
          delete pendingPromises[promiseKey]
        })
    })

    // 진행 중인 Promise로 등록
    pendingPromises[promiseKey] = promise
    return promise
  }
}
